import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import type { UserRole } from '../types';
import { keys } from './keys';

type Variables = {
  spaceId: string;
  firstName: string;
  lastName: string;
  email: string;
  role: UserRole;
};

async function inviteMember(variables: Variables) {
  const { data, error } = await apiClient.functions.invoke('invite-member', {
    body: {
      email: variables.email,
      firstName: variables.firstName,
      lastName: variables.lastName,
      spaceId: variables.spaceId,
      role: variables.role,
    },
  });

  if (error) {
    throw error;
  }

  if (data?.message) {
    throw new Error(data.message);
  }

  return data as { success: boolean; userId: string; created: boolean };
}

export default function useAddSpaceMember() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: Variables) => inviteMember(variables),
    onSuccess: (data, variables) => {
      const message = data.created
        ? 'Membre créé et ajouté.'
        : 'Membre ajouté.';
      enqueueSnackbar(message, 'success');
      queryClient.invalidateQueries({ queryKey: keys.members(variables.spaceId) });
    },
  });
}
